import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField } from '@mui/material';

const MassDanceDialog = ({ open, onClose, onSend, onRemoveAll, maxPairs }) => {
    const [selected, setSelected] = useState(1);
    const [customValue, setCustomValue] = useState('');

    const buttons = Array.from({ length: 50 }, (_, i) => i + 1);

    const handleSend = () => {
        const count = customValue ? parseInt(customValue, 10) : selected;
        if (count && count > 0 && count <= maxPairs) {
            onSend(count);
            handleClose();
        }
    };

    const handleAddAll = () => {
        onSend(maxPairs);
        handleClose();
    };

    const handleRemoveAll = () => {
        onRemoveAll();
        handleClose();
    };

    const handleClose = () => {
        setCustomValue('');
        setSelected(1);
        onClose();
    };

    const handleNumberClick = (num) => {
        setSelected(num);
        setCustomValue('');
    };

    const handleCustomChange = (e) => {
        setCustomValue(e.target.value);
        setSelected(null);
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Вывести пары на танцпол</DialogTitle>
            <DialogContent>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(5, 1fr)',
                        gap: 1,
                        padding: 1,
                    }}
                >
                    {buttons.map((number) => (
                        <Button
                            key={number}
                            variant={selected === number ? 'contained' : 'outlined'}
                            size="small"
                            onClick={() => handleNumberClick(number)}
                        >
                            {number}
                        </Button>
                    ))}
                </Box>
                <TextField
                    fullWidth
                    label="Или введите число"
                    type="number"
                    value={customValue}
                    onChange={handleCustomChange}
                    sx={{ mt: 2 }}
                    inputProps={{ min: 1, max: maxPairs }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Отменить</Button>
                <Button onClick={handleRemoveAll} color="error">Убрать всех</Button>
                <Button onClick={handleAddAll} color="success">Добавить всех</Button>
                <Button
                    onClick={handleSend}
                    variant="contained"
                    disabled={!selected && !customValue}
                >
                    Отправить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MassDanceDialog;
